var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNoImages(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 101,
    height: 100,
    viewBox: "0 0 101 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "noun-no-image-3674275 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M74.1805 47.0913C74.1805 44.5713 72.1406 42.5312 69.6206 42.5312C67.1006 42.5312 65.0605 44.5713 65.0605 47.0913C65.0605 49.6113 67.1006 51.6513 69.6206 51.6513C72.1306 51.6513 74.1805 49.6113 74.1805 47.0913Z",
    fill: "#BDBDBD"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M25.6597 67.2597L28.8997 64.0197L17.6497 33.1897L61.7097 17.1697L65.4497 27.4697L68.6897 24.2297L64.9097 13.7997C64.7097 13.2797 64.3397 12.8597 63.8397 12.6297C63.3397 12.3897 62.7697 12.3697 62.2497 12.5597L14.2797 30.0097C13.7597 30.1897 13.3397 30.5797 13.0997 31.0797C12.8797 31.5797 12.8397 32.1497 13.0297 32.6697L25.6597 67.2597Z",
    fill: "#BDBDBD"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M54.5909 53.5106H54.5709L29.7109 78.3706L30.5409 80.6306C30.8409 81.4806 31.6309 82.0006 32.4809 82.0006C32.6309 82.0006 32.7809 81.9606 32.9209 81.9306V85.5206C32.9209 86.6906 33.8109 87.5706 34.9709 87.5706H85.9809C87.1509 87.5706 88.0709 86.6806 88.0709 85.5206V34.5006C88.0709 33.3306 87.1509 32.3906 85.9809 32.3906H75.6809L71.5209 36.5506H83.9309V68.1206L80.9309 63.6306C79.8209 62.0806 78.0409 61.1006 76.1209 61.1006C74.1809 61.1006 72.4009 62.0806 71.2909 63.6906L68.4009 67.9606L58.2309 55.5506C57.3409 54.4406 55.9009 53.6806 54.5909 53.5106Z",
    fill: "#BDBDBD"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M32.9297 34.5006V59.9906L37.0897 55.8306V36.5506H56.3597L60.5197 32.3906H34.9797C33.8197 32.3906 32.9297 33.3306 32.9297 34.5006Z",
    fill: "#BDBDBD"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M84.7907 11.7788L12.2807 84.2887C11.2007 85.3688 11.2007 87.1287 12.2807 88.2087C12.8207 88.7487 13.5307 89.0187 14.2407 89.0187C14.9507 89.0187 15.6607 88.7487 16.2007 88.2087L88.7107 15.6988C89.7907 14.6188 89.7907 12.8588 88.7107 11.7788C87.6307 10.6988 85.8807 10.6988 84.7907 11.7788Z",
    fill: "#BDBDBD"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoImages);
export default __webpack_public_path__ + "static/media/no-images.6b16172ad4d5ec65efc6ad22fd77b8ee.svg";
export { ForwardRef as ReactComponent };